import { React, useState, useEffect } from 'react';

import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from '@mantine/core';

import LogoNavbar from '../../../composents/Logo/NavbarLogo/Logo';

const PaymentCanceled = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 

  const reference = searchParams.get("ref");

useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
        window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

    return(
        <div className={isMobile ? "width95pCenter" : "width50pCenter"}>
            <LogoNavbar />
            <h3>Paiement annulé</h3>
            <div className="bLiteGrey">
                <div className="width90pCenter">
                    <div>
                        {reference && (
                        <p><strong>Référence :</strong> {reference}</p>
                        )}

                        <p className="padT20">
                        Votre paiement n’a pas été finalisé.
                        </p>

                        <p>
                        Aucun montant n’a été débité.
                        </p>
                    </div>

                    <div>
                        <p>
                        Vous pouvez relancer le paiement lorsque vous serez prêt.
                        </p>
                        <p className="padB20">
                        En cas de difficulté, contactez le support.
                        </p>
                    </div>
                </div>
            </div>
            <div className="vertical">
                <Button
                    className="mrgB20"
                    color="green"
                    onClick={() => navigate(-1)}
                >
                Réessayer le paiement
                </Button>

                <Button
                    variant="outline"
                    color="green"
                    onClick={() => navigate("/app/research/list")}
                >
                Retour application
                </Button>
            </div>
        </div>
    )
};

export default PaymentCanceled;